import ExcludedPlugins from '../store/schema/ExcludedPlugins';
import { orderedEditorPlugins, PluginKey } from '../store/schema/IEditorPlugins';
import { EditorPlugin } from 'roosterjs-editor-types';

export default function getPluginArray<TExcluded extends PluginKey>(
    plugins: ExcludedPlugins<TExcluded>
): EditorPlugin[] {
    const includedKeys = Object.keys(plugins);
    const pluginKeyOrder = Object.keys(orderedEditorPlugins);

    const orderedKeys = pluginKeyOrder.filter(key => includedKeys.indexOf(key) >= 0);
    return orderedKeys.map(key => plugins[key]);
}
